import { CircularProgress, IconButton } from "@mui/material";
import { useSelector } from "react-redux";
import { iconButtonSxProps } from "../../helpers";
import { selectProfilePermissionsSelector } from "../../../store/api/auth/selectors";
import { useStoreDispatch } from "../../../store/hooks";
import ProfilePermissions from "../../../utils/ProfilePermissions";
import DownloadOutlinedIcon from "@mui/icons-material/DownloadOutlined";
import { IFiles } from "../../../store/api/deviceConfig/types";
import { useState } from "react";
import { useGetDownloadFileMutation } from "../../../store/api/deviceConfig/deviceConfigApiSlice";
import { setOpenToast } from "../../../store/helpers/helperReducers";
import { downloadFile, errorMessage } from "../../../utils/helpers";
import { useLocation } from "react-router-dom";
/*
 * Copyright 2022, Corning Optical Communications
 * All Rights Reserved.
 */

interface IRowData {
  rowData: IFiles;
  fileType: string;
}
const DownloadFile: React.FC<IRowData> = ({ rowData,fileType }) => {
  const dispatch = useStoreDispatch();
  const permissions: ProfilePermissions | null = useSelector(selectProfilePermissionsSelector);
  const [getDownloadFIle, res] = useGetDownloadFileMutation();
  const [isLoading, setIsLoading] = useState(false);
  const location = useLocation();
  const locationPath = location?.pathname.split("/");
  const fileName = encodeURIComponent(rowData.fileName);
  const downloadClickHandler = async (event: any) => {
    event.preventDefault();
    event.stopPropagation();
    const args = {
      filters: `fileType=${fileType}&fileName=${fileName}`,
      deviceKey: locationPath[2], //rowData.parentKey,
    };
    try {
      setIsLoading(true);
      const response: any = await getDownloadFIle(args);
      if (response?.error || res.isError) throw response?.error || res.error;
      downloadFile(response, rowData.fileName);
      setIsLoading(false);
    } catch (error: any) {
      setIsLoading(false);
      dispatch(setOpenToast({ openToast: true, toastType: "error", message: errorMessage(error) }));
    }
  };

  return permissions?.hasOpCodeGroup("manage_sn") && !isLoading ? (
    <IconButton sx={iconButtonSxProps} size="small" title="Download">
      <DownloadOutlinedIcon sx={{ color: "var(--foreground)" }} onClick={downloadClickHandler} />
    </IconButton>
  ) : (
    <CircularProgress size={20} color="primary" />
  );
};

export default DownloadFile;
